import React from 'react';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const useStyles = makeStyles(theme => ({
  button: {
    marginTop: 20,
    marginBottom: 10
  },
  errorText: {
    marginTop: 20,
    color: theme.palette.error.main
  }
}));

export default function ThreadForm(props) {
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);
  const [bodyData, setBodyData] = React.useState({
    title: '',
    creator: '',
    description: ''
  });
  const [valueError, setValueError] = React.useState({
    title: false,
    creator: false,
  });
  const [postError, setPostError] = React.useState({
    error: false,
    status: null,
    statusText: ''
  });

  const postData = () => {
    setValueError({title: !bodyData.title, creator: !bodyData.creator});
    if (bodyData.title && bodyData.creator) {
      axios.post("/keijiban/threads", bodyData)
        .then(res => (res.status == 201) && window.location.reload())
        .catch(err => setPostError({error: true, status: err.response.status, statusText: err.response.statusText}));
    } else {
      setPostError({...postError, error: false});
    }
  };

  return (
    <div>
      <Button variant='contained' color='primary' className={classes.button} onClick={() => setOpen(true)}>
        新規
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth  aria-labelledby='form-dialog-title'>
        <DialogTitle id='form-dialog-title'>スレッドの新規作成</DialogTitle>
        <DialogContent>
          <DialogContentText>
            新たに作成するスレッド名と簡単な説明を入力してください
          </DialogContentText>
          <TextField
            autoFocus
            required
            margin='dense'
            id='name'
            label='お名前'
            helperText={valueError.creator && '必ず入力してください'}
            onChange={e => setBodyData({...bodyData, creator: e.target.value})}
            error={valueError.creator}
          />
          <TextField
            autoFocus
            required
            margin='dense'
            id='title'
            label='スレッド名'
            helperText={valueError.title && '必ず入力してください'}
            fullWidth
            onChange={e => setBodyData({...bodyData, title: e.target.value})}
            error={valueError.title}
          />
          <TextField
            autoFocus
            margin='dense'
            id='description'
            label='スレッドの説明'
            multiline
            rows={2}
            fullWidth
            onChange={e => setBodyData({...bodyData, description: e.target.value})}
          />
          <DialogContentText className={classes.errorText}>
            {postError.error && `サーバーへの送信に失敗しました ${postError.status} (${postError.statusText})`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => postData()} color='primary'>
            作成
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
